import React, { useState, useRef } from 'react';
import axios from 'axios';

const AddEventForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    startDate: '',
    endDate: '',
    status: 'active',
    eventFee: ''
  });

  const [saving, setSaving] = useState(false);
  const submitGuard = useRef(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitGuard.current) return;
    submitGuard.current = true; setSaving(true);
    try {
      const res = await axios.post('/api/events', { ...formData, isActive: formData.status === 'active' });
      alert('✅ Event created: ' + res.data.name);
      setFormData({ name: '', startDate: '', endDate: '', status: 'active', eventFee: '' });
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || 'Unable to create event. Check the connection and retry.');
    } finally { submitGuard.current = false; setSaving(false); }
  };

  return (
    <div className="max-w-2xl mx-auto bg-white p-6 mt-8 shadow rounded">
      <h2 className="text-xl font-bold mb-4">Create New Event</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input type="text" name="name" value={formData.name} onChange={handleChange} aria-label="Event Name" placeholder="Event Name" className="border p-2 rounded w-full" required />

        <select aria-label="Event Status" name="status" value={formData.status} onChange={handleChange} className="border p-2 rounded w-full">
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>

        <div className="flex gap-4">
          <input type="date" aria-label="Start Date" name="startDate" value={formData.startDate} onChange={handleChange} className="border p-2 rounded w-full" required />
          <input type="date" aria-label="End Date" name="endDate" value={formData.endDate} onChange={handleChange} className="border p-2 rounded w-full" required />
        </div>

        <input
          type="number"
          name="eventFee"
          aria-label="Event Fee" min="0" step="0.01"
          value={formData.eventFee}
          onChange={handleChange}
          placeholder="Event Fee"
          className="border p-2 rounded w-full"
          required
        />

        <button type="submit" disabled={saving} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">{saving ? 'Saving…' : 'Save Event'}</button>
      </form>
    </div>
  );
};

export default AddEventForm;